import { render, staticRenderFns } from "./colorPickerTest.vue?vue&type=template&id=0c64fd97&scoped=true&"
import script from "./colorPickerTest.vue?vue&type=script&lang=js&"
export * from "./colorPickerTest.vue?vue&type=script&lang=js&"
import style0 from "./colorPickerTest.vue?vue&type=style&index=0&id=0c64fd97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64fd97",
  null
  
)

export default component.exports